import { mergeNewBits } from "./utils/ReducerUtils";

export default function onPriorityBitsLoaded(state, payload) {
  return Object.assign({}, state, {
    bits: mergeNewBits(payload.tasks, state),
    priorityBitIds: payload.tasks.map(it => it.id)
  });
}
